var map = {
	"./about/a1.jpg": 5508,
	"./about/a2.jpg": 3635,
	"./about/a3.jpg": 1462,
	"./avatars/bu.png": 2118,
	"./avatars/hm.png": 6808,
	"./avatars/lc.png": 1106,
	"./avatars/sanasa-30.png": 6776,
	"./avatars/sanasa-40.png": 9417,
	"./avatars/sg.png": 9007,
	"./backgrounds/breadcrumb.jpg": 1057,
	"./backgrounds/offer-bg.jpg": 5380,
	"./fallback/person.jpg": 3408,
	"./fallback/picture-card.jpg": 9978,
	"./fallback/picture-side.jpg": 225,
	"./fallback/picture-wide.jpg": 8957,
	"./faq/faq.jpg": 763,
	"./gallery/g1.jpg": 7917,
	"./gallery/g2.jpg": 1986,
	"./gallery/g3.jpg": 3695,
	"./gallery/g4.jpg": 5908,
	"./gallery/g5.jpg": 241,
	"./gallery/g6.jpg": 2486,
	"./gallery/g7.jpg": 1971,
	"./gallery/g8.jpg": 7512,
	"./home/about-1.jpg": 7313,
	"./home/about-2.jpg": 614,
	"./home/testimonial.jpg": 4941,
	"./icons/banking.svg": 2385,
	"./icons/diplomas.svg": 3644,
	"./icons/insurance.svg": 8627,
	"./icons/planning.svg": 2938,
	"./icons/training.svg": 7499,
	"./research/research-1.jpg": 6881,
	"./research/research-2.jpg": 7270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2868;